import ErrorBoundary from 'sharedComponents/ErrorBoundary';
import { lazy, Suspense } from 'react';
import { Spinner } from '@7shifts/sous-chef';

const AdminDashboardPage = lazy(() => import('./pages/AdminDashboardPage'));

export const ROUTES = [
    {
        path: '/dashboard',
        element: (
            <Suspense fallback={<Spinner block />}>
                <AdminDashboardPage />
            </Suspense>
        ),
        errorElement: <ErrorBoundary />
    }
];
